import { cardsData } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新爆料</h2>
          <p className="text-sm text-foreground-500 mt-2">一手资讯 · 深度扒皮 · 不容错过</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card) => (
            <div key={card.id} className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) parent.classList.add('hidden');
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}